import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=6ced1676&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=ts"
export * from "./Trades.vue?vue&type=script&lang=ts"
import style0 from "./Trades.vue?vue&type=style&index=0&id=6ced1676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced1676",
  null
  
)

export default component.exports